function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
  fill: "current",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100 420 c-10 -6 -11 -10 -2 -10 7 0 12 -14 12 -37 l0 -38 -20 30 c-12 18 -20 24 -20 15 0 -9 -14 -20 -32 -25 -28 -8 -34 -15 -36 -43 -2 -24 2 -38 14 -47 16 -11 20 -10 29 9 15 30 76 30 90 -1 l9 -21 11 21 c16 32 75 31 91 -1 l12 -24 19 21 c21 23 103 62 115 55 11 -7 10 -32 -2 -36 -6 -2 -6 -16 1 -40 7 -27 15 -38 29 -38 24 0 24 0 5 36 -13 26 -13 29 3 36 16 6 16 7 0 7 -10 1 -18 8 -18 16 0 17 65 22 75 5 3 -6 -4 -10 -16 -10 -40 0 -15 -9 39 -13 60 -6 76 7 41 34 -33 26 -79 36 -187 43 -65 4 -98 2 -112 -6 -17 -11 -22 -10 -30 2 -8 13 -10 12 -10 -2 0 -15 -9 -18 -45 -18 -45 0 -45 0 -45 35 0 34 1 35 40 35 31 0 40 -4 41 -17 0 -15 2 -15 8 2 7 17 3 21 -28 27 -50 10 -64 9 -81 -2z m-43 -96 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54 276 c-9 -23 -1 -48 18 -60 26 -16 53 4 53 40 0 25 -4 29 -33 32 -22 2 -34 -2 -38 -12z m54 -24 c3 -17 -2 -22 -17 -22 -14 0 -21 6 -21 18 0 38 33 41 38 4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164 276 c-9 -23 -1 -48 19 -60 25 -16 52 4 52 40 0 25 -4 29 -33 32 -22 2 -34 -2 -38 -12z m54 -24 c3 -17 -2 -22 -17 -22 -14 0 -21 6 -21 18 0 38 33 41 38 4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 276 c-15 -40 21 -80 54 -60 37 24 21 74 -25 74 -13 0 -26 -6 -29 -14z m56 -22 c0 -19 -28 -30 -42 -16 -8 8 -8 15 1 26 14 17 41 10 41 -10z"
}));

var SvgVehicle9 = function SvgVehicle9(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVehicle9, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle9.1d77a563.svg";
export { ForwardRef as ReactComponent };